/** @jsx jsx */
import { useRouter } from 'next/router';
import { useState } from 'react';
import { jsx } from '@balance-web/core';
import { Stack } from '@balance-web/stack';
import { Heading } from '@balance-web/heading';
import { Text } from '@balance-web/text';
import { Button } from '@balance-web/button';
/*const checkCallBackRegex = new RegExp(
  `${process.env.oauthRedirectSignIn}(.*?)/(.*?)/#`
);*/

const Custom404 = () => {
  const [valid404 /*, setValid404*/] = useState<boolean>(false); // FIXME: what's the point of this?
  const router = useRouter();

  return valid404 ? (
    <Stack align="center" gap="xxlarge" css={{ marginTop: 100 }}>
      {/* FIXME: images must have alt text */}
      <img src="./reckon-payroll-404.svg" alt="" />
      <Heading level="3">Page not found</Heading>
      <Text
        color="muted"
        size="small"
        leading="loose"
        weight="medium"
        align="center"
      >
        We can't find the page you're looking for. It might be an old link{' '}
        <br />
        or may be it moved.
      </Text>
      <Button
        id="404-go-home"
        label="Go to Homepage"
        onClick={() => router.push('/')}
      />
    </Stack>
  ) : null;
};

export default Custom404;
